import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, PersistableAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { User } from './user.model';
import { UserFilters } from './user.reducer';

export const ENTITY = 'user';
export const SELECT = '[User] Select';
export const SUBMIT = '[User] Submit';
export const REHYDRATE = '[User] Rehydrate';
export const REMOVE = '[User] Remove';
export const SET_FILTER = '[User] Set Filter';

export class SetAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SELECT;

    constructor(public payload: string, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:selected`;
    }
}

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: User, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<User>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: User, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: UserFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }

}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction
    | SetAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.actions.ts